import React from 'react';
import { number, string } from 'prop-types';

const IconTarget = ({ size = 24, fill = '#30435D' }) => {
  return (
    <svg data-test="icontarget" width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path
        d="M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12Z"
        stroke={fill}
        strokeWidth="2"
      />
      <path
        d="M18.1998 12.0008C18.1998 15.4249 15.424 18.2008 11.9998 18.2008C8.57564 18.2008 5.7998 15.4249 5.7998 12.0008C5.7998 8.57662 8.57564 5.80078 11.9998 5.80078C15.424 5.80078 18.1998 8.57662 18.1998 12.0008Z"
        stroke={fill}
        strokeWidth="2"
      />
      <path
        d="M13.4001 11.9996C13.4001 12.7728 12.7733 13.3996 12.0001 13.3996C11.2269 13.3996 10.6001 12.7728 10.6001 11.9996C10.6001 11.2264 11.2269 10.5996 12.0001 10.5996C12.7733 10.5996 13.4001 11.2264 13.4001 11.9996Z"
        stroke={fill}
        strokeWidth="2"
      />
    </svg>
  );
};

IconTarget.propTypes = {
  size: number,
  fill: string,
};

export default IconTarget;
